"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Uniform = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createComponent = createComponent;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _connectSize = require("./connectSize");

var _connectSize2 = _interopRequireDefault(_connectSize);

var _Bus = require("./Bus");

var _Bus2 = _interopRequireDefault(_Bus);

var _LinearCopy = require("./LinearCopy");

var _LinearCopy2 = _interopRequireDefault(_LinearCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function warn(method, alternative) {
  console.warn("gl-react: " + method + " is deprecated. " + alternative);
}

function createComponent(renderGLNode, staticFields) {
  warn("createComponent(" + String(renderGLNode) + ")", "You can now just use a normal React Component (or a stateless component function). \n" + "If you need the contextual {width,height} props, use connectSize() decorator.");
  var C = (0, _connectSize2.default)(renderGLNode);
  Object.assign(C, staticFields);
  return C;
}

var Uniform = exports.Uniform = function (_React$Component) {
  _inherits(Uniform, _React$Component);

  function Uniform(_ref) {
    var name = _ref.name;

    _classCallCheck(this, Uniform);

    var _this = _possibleConstructorReturn(this, (Uniform.__proto__ || Object.getPrototypeOf(Uniform)).call(this));

    warn("GL.Uniform", "Please directly use <Node uniforms={{ " + name + ": value }}>\nYou might also need to use <Bus> if you want to reuse content.");
    return _this;
  }

  _createClass(Uniform, [{
    key: "render",
    value: function render() {
      var children = this.props.children;

      if (!_react2.default.isValidElement(this.props.children)) {
        children = // LinearCopy to the rescue!
        _react2.default.createElement(
          _LinearCopy2.default,
          null,
          children
        );
      }
      return _react2.default.createElement(
        _Bus2.default,
        { uniform: this.props.name },
        children
      );
    }
  }]);

  return Uniform;
}(_react2.default.Component);
//# sourceMappingURL=legacy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/legacy.js
// module id = 181
// module chunks = 0